// Single source of truth for site-wide SEO metadata.
// Zero imports allowed in this file.

export const SITE_ORIGIN = 'https://www.riverside-shuttle.com';
export const SITE_NAME = 'Riverside Transfers';
export const OG_IMAGE_PATH = '/og/og-default.jpg';
export const BOOKING_EMAIL = 'booking@tickets.riverside-shuttle.com';

export const CORE_PAGES = [
  {
    path: '/',
    title: 'Riverside Transfers | Nairobi–Arusha–Moshi Shuttles',
    description:
      // Keep in sync with src/seo/priceDisplay.js (from £28 (about $37) without the leading "from ").
      'Book shuttle bus tickets or private transfers between Nairobi, Arusha and Moshi. Daily departures, hotel pickup, instant confirmation, from £28 (about $37).',
  },
  {
    path: '/bus',
    title: 'Shuttle Bus Tickets | Nairobi–Arusha–Moshi from £28 (about $37)',
    description:
      // Keep in sync with src/seo/priceDisplay.js.
      'Daily shuttle buses between Nairobi, Arusha and Moshi from £28 (about $37). Hotel pickup included, instant e-ticket confirmation, free date changes.',
  },
  {
    path: '/private-transfer',
    title: 'Private Transfers | Nairobi, Arusha & Moshi',
    description:
      'Get an instant quote for a private vehicle transfer anywhere in Kenya or Tanzania. Your own schedule, door-to-door, whole vehicle to yourselves.',
  },
  {
    path: '/schedule',
    title: 'Shuttle Timetable | Nairobi–Arusha–Moshi Daily Departures',
    description:
      'Daily shuttle departure and arrival times between Nairobi, JKIA, Namanga, Arusha and Moshi. Hotel pickup and report-by times for Riverside Shuttle buses.',
  },
  {
    path: '/booking-conditions',
    title: 'Booking Conditions & Cancellation Policy',
    description:
      "Read Riverside Transfers' booking conditions, cancellation policy and refund terms before you book your shuttle or private transfer.",
  },
  {
    path: '/privacy',
    title: 'Privacy Policy | Riverside Transfers',
    description:
      'How Riverside Transfers collects, uses and protects your personal data, who we share it with, how long we keep it, and how to exercise your rights.',
  },
];

export const NOINDEX_PATH_PREFIXES = [
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/profile',
  '/my-trips',
  '/messages',
  '/admin',
  '/manage',
  '/success',
  '/create',
  '/trips',
  '/pricing-demo',
  '/notification-test',
];
